import { useSidebar } from '@/components/ui/sidebar'
import { Icon } from '@/components/Icon'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { useRecentAgentsStore } from '@/stores/recentAgentsStore'
import { useNavigate } from 'react-router-dom'

export function HistoryMain() {
  const { open } = useSidebar()
  const navigate = useNavigate()
  const { getRecentAgents } = useRecentAgentsStore()

  // 获取近期使用的智能体列表
  const recentAgents = getRecentAgents()

  // 处理智能体点击
  const handleAgentClick = (agentId: string) => {
    navigate(`/agents/chat/${agentId}`)
  }

  return (
    <div className="overflow-hidden">
      <div className="flex items-center w-full text-[16px] px-3 text-[#666666] h-[48px] border-b-2 border-[#8752FF1A]">
        <Icon name="time" className="flex-none" color="#898DA4" />
        {open && <p className="mx-2 whitespace-nowrap">近期使用</p>}
      </div>
      <ul className="text-base text-[#666666] text-left py-1 [&>li:hover]:bg-[#8752FF1A] [&>li]:cursor-pointer [&>li]:px-4">
        {recentAgents.length > 0 ? (
          recentAgents.map((agent) => (
            <li
              key={agent.id}
              className="flex items-center justify-between h-[48px]"
              onClick={() => handleAgentClick(agent.id)}
            >
              <div className="flex items-center gap-2">
                <Avatar className="h-5 w-5 rounded-full">
                  <AvatarImage src={agent.icon} alt={agent.name} />
                  <AvatarFallback className="rounded-full text-[12px]">
                    {agent.name.slice(0, 1)}
                  </AvatarFallback>
                </Avatar>
                {open && (
                  <span className="whitespace-nowrap">{agent.name}</span>
                )}
              </div>
            </li>
          ))
        ) : (
          <li className="flex items-center justify-center h-[48px] text-[#999999] text-sm">
            {open && <span>暂无近期使用</span>}
          </li>
        )}
      </ul>
    </div>
  )
}
